"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgTennisFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M21.965 10.77a10.005 10.005 0 00-8.736-8.734 11.012 11.012 0 008.736 8.735zM22 12.808A13.01 13.01 0 0111.193 2a10.002 10.002 0 00-9.123 9.123A13.01 13.01 0 0112.877 21.93 10.003 10.003 0 0022 12.807zm-11.16 9.088a11.011 11.011 0 00-8.735-8.735 10.005 10.005 0 008.735 8.735z' }))); };
exports.default = SvgTennisFilled;
//# sourceMappingURL=TennisFilled.js.map